<template>
    <div class="fabric-wrap section-wrap">
        <div class="left">
            <div class="collapse-title">面料选择</div>
            <div class="collapse-content">
                <div class="list">
                    <div class="item">
                        <span class="name">材质</span>
                        <span class="value" :title="current_fabric.fabric_name_cn">{{current_fabric.fabric_name_cn}}</span>
                    </div>
                </div>
                <div class="list">
                    <div class="item">
                        <span class="name">面料</span>
                        <span class="value">{{current_color.color_name_cn}}</span>
                    </div>
                </div>
                <div class="list" v-show="current_fabric.fabric_price>0">
                    <div class="item">
                        <span class="name">价格</span>
                        <span class="value">￥ {{(current_fabric.fabric_price || 0) | price_format }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="cate-box">
                <div class="cate" v-for="(color, index) in color_list"  @click="change_tip(color.color_value, color.color_key, color.fabric_key)"
                     :class="{
                active: unique_key == `${color.fabric_key}${color.color_key}${color.color_value}`,
                'select-active':unique_key == `${color.fabric_key}${color.color_key}${color.color_value}`}">
                    <img class="magnifier" src="@/assets/images/magnifier.png" @click.stop="mag(color.color_thumb ? color.color_thumb : color.color_value)"/>
                    <img class="img" v-lazy="`${(color.color_thumb ? color.color_thumb : color.color_value) + '?x-oss-process=image/resize,w_100,h_100,m_pad,color_FFFFFF'}`" alt="" :key="'lazy-'+index">
                    <div class="name"> {{ color.color_name_cn }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "Fabric",
        data(){
            return {

            }
        },
        computed: {
            ...mapState({
                // 款式的可选材质+布料颜色信息
                fabric_list: (state) => state.mtm.picked_category.hasOwnProperty('fabric') ? state.mtm.picked_category.fabric : Array.of(),
                // 当前选中材质
                current_fabric(state) {
                    return state.mtm.form_data.fabric_list.material
                },
                // 当前选中布料颜色
                current_color(state) {
                    return {...state.mtm.form_data.fabric_list.color, fabric_key: this.current_fabric?.fabric_key}
                },
                style_data: (state) => state.mtm.form_data.customize_data,
            }),
            // 选项的唯一标识，拼接
            unique_key() {
                return `${this.current_fabric.fabric_key}${this.current_color.color_key}${this.current_color.color_value}`
            },
            // 款式的所有可选材质+布料颜色信息，合并为一个数组
            color_list() {
                let result = [];
                this.fabric_list.forEach((fabric_item, index) => {
                    let color_list = fabric_item.color_list
                    for(let color_index=0;color_index<color_list.length;color_index++) {
                        result.push({...color_list[color_index],
                            fabric_key: fabric_item.fabric_key,
                            fabric_name_cn:fabric_item.fabric_name_cn,
                            fabric_price: fabric_item.fabric_price
                        })
                    }
                })
                return result
            },
            fabric_plus_price() {
                let a = Math.round(this.current_fabric.fabric_price*100) / 100
                return isNaN(a) ? `` : '￥ '  + a.toFixed(2)
            }
        },
        methods: {
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            change_tip(color_value, color_key, fabric_key) {
                if(this.style_data.length) {
                    this.$Modal.confirm({
                        title: '注意',
                        content: '更换面料将清空当前文字等个性定制信息，是否继续？',
                        onOk: () => {
                            this.$store.commit('mtm/reset_customize_data')
                            this.select_color(color_value, color_key, fabric_key)
                        },
                        onCancel: () => {
                        }
                    });
                } else {
                    this.select_color(color_value, color_key, fabric_key)
                }
            },
            select_color(color_value, color_key, fabric_key) {
                let selected_fabric = this.fabric_list.find((v) => {
                    return v.fabric_key === fabric_key
                })
                let selected_color = selected_fabric.color_list.find((v) => {
                    return v.color_key === color_key && v.color_value === color_value
                })
                this.$store.commit('mtm/choose_fabric', {
                    material: selected_fabric,
                    color: selected_color
                })
            },
            colorValue(color_value) {
                if (color_value.indexOf("http") >= 0) {
                    return `background-image:url(${color_value + '?x-oss-process=image/resize,w_100,h_100,m_pad,color_FFFFFF'});background-size:cover`;
                }
                return "background:" + color_value;
            }

        },
        mounted() {
            if(Object.keys(this.current_fabric).length === 0) {
                this.select_color(this.color_list[0].color_value, this.color_list[0].color_key, this.color_list[0].fabric_key)
            }
        }
    }
</script>

<style lang="scss" scoped>
    // chrome,safari浏览器滚动条适配
    ::-webkit-scrollbar {
        width: 10px;
        height: 3px;
    }

    ::-webkit-scrollbar-track {
        background: #eee;
        border-radius: 2px;
    }

    ::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #ddd
    }

    ::-webkit-scrollbar-corner {
        background: #ddd;
    }

    .section-wrap {
        .left {
            position: absolute;
            top: 0;
            left: 0;
            width: 270px;
            height: 99.5%;
            overflow-y: scroll;

            .collapse-title {
                width: 100%;
                height: 44px;
                line-height: 44px;
                background: #FAFAFA;
                text-align: left;
                font-size: 14px;
                color: #0F114A;
                padding: 0 20px;
                font-weight: bold;
                user-select: none;
            }

            .collapse-content {
                .list {
                    padding: 0 20px;

                    .item {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        color: #000;
                        height: 44px;

                        .name {
                            font-size: 14px;

                            .red {
                                color: red;
                            }
                        }

                        .value {
                            font-size: 12px;
                            max-width: 80%;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }

                }
            }
        }

        .right {
            position: absolute;
            top: 5px;
            right: 0;
            width: 1080px;
            height: 98%;
            overflow-y: scroll;

            .cate-box {
                margin: 20px 10px;
                display: flex;
                flex-wrap: wrap;

                .radio-wrap {
                    width: 100%;
                    height: 30px;
                }
                .cate {
                    position: relative;
                    width: 200px;
                    margin: 10px 5px;
                    font-size: 15px;
                    font-weight: 400;
                    color: #666666;
                    text-align: center;
                    border-radius: 2px;
                    cursor: pointer;

                    .img {
                        width: 200px;
                        height: 200px;
                        padding: 25px;
                        border: 1px solid #DDDDDD;
                        box-sizing: border-box;
                    }

                    .magnifier {
                        position: absolute;
                        top: 150px;
                        right: 10px;
                        width: 40px;
                        height: 40px;
                        z-index: 10;
                    }

                    .name {
                        margin-top: 10px;
                    }

                    &.cate-active {
                        .img {
                            border: 1px solid #0f114a;
                        }

                        .name {
                            font-weight: bold;
                            color: #0F114A;
                        }
                    }
                }
            }
        }
    }

    .select-active {
        position: relative;
    }

    .select-active:after {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/images/design/select@2x.png");
        background-size: 100%;

        content: "";
    }
</style>

